export const books = [
  {
    id: 1,
    img: "https://m.media-amazon.com/images/I/41nIJTI4vXL._SY346_.jpg",
    title: "If You Tell: A True Life Story",
    author: "Gregg Olsen",
  },

  {
    id: 2,
    img: "https://images-na.ssl-images-amazon.com/images/I/4172Tn7FUJL._SY264_BO1,204,203,200_QL40_ML2_.jpg",
    title: "The Audacity",
    author: "Katherine Ryan",
  },

  {
    id: 3,
    img: "https://images-na.ssl-images-amazon.com/images/I/61k5YUaOrZL._SY498_BO1,204,203,200_.jpg",
    title: "Love You Forever",
    author: "Robert Munsch and Sheila McGraw",
  },

  {
    id: 4,
    img: "https://images-na.ssl-images-amazon.com/images/I/41RjSV2afHL._SX493_BO1,204,203,200_.jpg",
    title:
      "I Choose to Calm My Anxiety: A Colorful, Picture Book About Soothing Strategies for Anxious Children",
    author: "Elizabeth Estrada",
  },

  {
    id: 5,
    img: "https://images-na.ssl-images-amazon.com/images/I/51BqKV6TlpL._SX331_BO1,204,203,200_.jpg",
    title: "The Nightingale: A Novel",
    author: "Kristin Hannah",
  },

  {
    id: 6,
    img: "https://images-na.ssl-images-amazon.com/images/I/41l2jXH2jEL._SX331_BO1,204,203,200_.jpg",
    title: "Call Me by Your Name: A Novel",
    author: "André Aciman",
  },
];
